import { User } from "lucide-react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import AuthService from "../service/AuthService";
import { useToastContext } from "../provider/ToastContext";

const service = new AuthService();
export default function SolicitarTrocaSenha() {
    const [email, setEmail] = useState("");
    const { msgAlerta, msgSucesso } = useToastContext();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        service.solicitarTrocaSenha(email).then(() => {
            msgSucesso("Solicitação enviada", "Se o email existir em nosso sistema, você receberá instruções para trocar sua senha.");
        }).catch((err) => {
            console.log(err);
            msgAlerta("Erro ao solicitar troca de senha", err?.data?.message);
        });
    }
    return (
        <div className="gradient-bg flex align-items-center justify-content-center p-4">
            <Card className="login-card shadow-4">
                <div className="text-center mb-4">
                    <div className="login-icon">
                        <img src="/logo.png" alt="Logo" width={80} />
                    </div>
                    <h2 className="mb-2">Solicitar troca de senha</h2>
                    <p className="text-muted">Informe seu email para trocar a senha</p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="email" className="block mb-2">
                            Email
                        </label>
                        <span className="p-input-icon-left w-full">
                            <User size={20} style={{ marginLeft: 8, marginRight: 8 }} />
                            <InputText
                                id="email"
                                type="email"
                                placeholder="seu@email.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full"
                                style={{ paddingLeft: 32 }}
                                required
                            />
                        </span>
                    </div>

                    <Button
                        type="submit"
                        label="Enviar"
                        className="w-full mb-3"
                    />
                </form>
            </Card>
        </div>
    )
}
